import { useEffect } from "react";
import { useLocation } from "react-router-dom";

const pageview = (url) => {
  if (window.gtag && process.env.REACT_APP_NODE_ENV === "production") {
    window.gtag("event", "page_view", {
      page_path: url,
    });
  }
};

const RouteChangeTracker = () => {
  const location = useLocation();

  useEffect(() => {
    pageview(location.pathname + location.search);
  }, [location]);

  return null;
};

export default RouteChangeTracker;
